import React from "react";

export default function BeneficiosComex({ icon, titulo, subtitulo }) {
  return (
    <div className=" h-[400px] flex flex-col w-full md:flex-row gap-10 justify-center ">
      <div className="flex-1 p-8 flex flex-col items-center text-center min-w-[260px] rounded-xl bg-sidom-blue hover:bg-sidom-orange hover:text-sidom-light cursor-pointer transition-colors duration-200">
        <div className="bg-sidom-light rounded-full w-20 h-20  flex items-center justify-center mb-4">
          <img
            src={`https://api.institucional.global.sidom.io${icon}`}
            alt={titulo}
            className="w-12 h-12 object-contain"
          />
        </div>
        <h3 className="text-xl text-sidom-orange hover:text-sidom-light font-bold mb-2">
          {titulo}
        </h3>
        <p className="text-sidom-light text-base">{subtitulo}</p>
      </div>
    </div>
  );
}
